import './App.css';
import whiteArrow from './imgs/arrow-white.png';

/**
 * Renders a list of code options for the user to select from and handles the selection process.
 * 
 * @param {Object} props - The component props.
 * @param {Array} props.currentQuestion - The current question's values.
 * @param {number} props.active - The index of the currently active code option.
 * @param {boolean} props.showNextQestion - Determines if the next question button should be shown.
 * @param {number} props.currentId - The ID of the current question.
 * @param {string} props.selectedValue - The value of the currently selected code option.
 * @param {Function} props.handleSetActive - Function to set the active code option.
 * @param {Function} props.handleShowNextQuestion - Function to toggle the visibility of the next question button.
 * @param {Function} props.handleSetSelectedValue - Function to set the selected value.
 * @param {Function} props.handleNextQuestion - Function to handle moving to the next question.
 * @returns {JSX.Element} The rendered list of code options and next question button.
 */
function ListOfCodes(props) {
    let listCodes;
    let hoursPerWeek = '';

    if(props.jobTitle === 'adult-education-teacher'){
      hoursPerWeek = props.hoursPerWeek;
    }

    // Function to handle user selection of an answer
    function handleSelectAnsnwer(event){
        const selectedValue = event.currentTarget.value;
        const varValue = event.currentTarget.getAttribute('data-varvalue');
        
        props.handleSetActive(Number(event.currentTarget.id));
        props.handleSetSelectedValue(selectedValue);

        // Call handleNextQuestion directly
        props.handleNextQuestion(event, props.id, varValue);
    }

    // Render questions based on the current question
    const codes = props.currentQuestion;
    if(codes && Array.isArray(codes)){
        listCodes = codes.map((codes, index) =>
            <div className='single-code'>
                <button onClick={handleSelectAnsnwer} className={props.active === index ? 'default-button active' : 'default-button'} data-answer={codes.code} id={index} key={index} value={codes.answerId} data-current={props.currentId}>{codes.code}{hoursPerWeek}</button>
            </div>
        )
    }

  return (
    <>
     <div className="question-wrapper">
      <div className="list-of-codes flex flex-row flex-wrap align-center align-stretch justify-center">
        {listCodes}
      </div>
    </div>
    </>
  );
}

export default ListOfCodes;